import { Avatar, Button, List, Tag, Typography, Col, Row, } from 'antd';
import moment from 'moment';
import { ArrowLeftOutlined, EditOutlined } from '@ant-design/icons';
import Task from '../../../models/Task';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import {selectShowTaskCard, setShowNotaDeCierreModal, setTaskFilters} from '../../../store/slice/taskSlice';
import './TaskMapDescription.less';
import { useNavigate } from 'react-router-dom';
import { createInitialNames, taskStateItems, taskStateUsers } from '../../../utils/functions';
import { rolPermission, stateTask } from '../../../utils/functions'
import User from '../../../models/User';
import { ReactComponent as CloseTask } from '../../../res/svg/close-task.svg';
import CloseNoteTaskModal from '../../Organisms/CloseNoteTaskModal/CloseNoteTaskModal';
import Anotaciones from '../Anotaciones/Anotaciones';
import { useState } from 'react';
import {AnotacionesModel} from '../../../models/UserTask';

interface TaskMapDescriptionProps {
  task: Task;
  showTaskForm: (show: boolean) => void;
}

function TaskMapDescription(props: TaskMapDescriptionProps) {
  let navigate = useNavigate();
  const { Title, Text } = Typography;
  const dispatch = useAppDispatch();
  const showTaskCard = useAppSelector(selectShowTaskCard);
  const [showNotas, setShowNotas] = useState<Boolean>(false);
  const [infoNotas, setInfoNotas] = useState<AnotacionesModel | undefined>();
  //@ts-ignore
  const currentUser: User = JSON.parse(localStorage.getItem('currentUser'))
  
  const navigateToTaskView = () => {
    //se regresa a la pantalla anterior, y se muestra si es el componente de las tarjetas o la tabla 
    if(showTaskCard){
      navigate(
        {
          pathname: '/tareas',
          search: '?display=tarjetas',
        }
      );
      //Limpiar filtros
      limpiarFiltros() 
    } else {
      navigate(
        {
          pathname: '/tareas',
          search: '?display=tabla',
        }
      );
      //Limpiar filtros
      limpiarFiltros()
    }
  };

  const editTaskForm = () => {
    props.showTaskForm(true);
  };

  const limpiarFiltros = () =>{
    dispatch(setTaskFilters({
      ordenarPor: undefined,
      tipoFecha:  undefined,
      fechaDesde: undefined,
      fechaHasta: undefined,
      estado:     undefined,
      creadasPor: [],
      tipoTarea: [],
      search: undefined,
      tareaUsuarioEstado: [],
      usuariosAsignados: [],
      page: 1,
      pageSize: 20,
    }))
  }

  const readOnly = () =>{
    let hide = false;
    if(currentUser.rol !== null){
      if(currentUser.rol.permiso === rolPermission.SUPERVISION || 
        currentUser.rol.permiso === rolPermission.EJECUCION || 
        props.task.estado === stateTask.CERRADA){
          hide = true
      }
    }
    return hide;
  }

  const showModalVerNotas = (inspector: string, nombreTarea: string, notas: string) =>{
    setShowNotas(true);
    setInfoNotas({inspector, nombreTarea, notas});
  }

  const closeModalVerNotas = () =>{
    setShowNotas(false);
  }

  return (
    <div className="tp-task-map__form__content">
        <div className="tp-task-map__form__inner_content">
          <div className="tp-task-map__description__content__title">
            <Title
              level={3}
              className="tp-task-map__description__content__title__text"
            >
              {props.task.titulo}
            </Title>
          </div>
          <div className="tp-task-map__description__content__assign">
            <Tag className={taskStateItems(props.task.estado as number).className}>
              {taskStateItems(props.task.estado as number).title}
            </Tag>
          </div>
          <div className="tp-task-map__description__content__created">
            <Text type="secondary">
              Creada por <b>{props.task.usuario?.nombre} {props.task.usuario?.apellido}</b> el{' '}
              {moment(props.task.createdAt).format('DD/MM/YYYY')}
            </Text>
          </div>
          <div className="tp-task-map__description__content__information">
            <Text strong>Tipo de tarea:</Text>
            <Text type="secondary">{props.task.tipotarea?.tipotarea}</Text>
          </div>
          <div className="tp-task-map__description__content__information">
            <Text strong>Descripción:</Text>
            <Text type="secondary">{props.task.descripcion ? props.task.descripcion : '-'}</Text>
          </div>
          <div className="tp-task-map__description__content__information">
            <Text strong>Observaciones:</Text>
            <Text type="secondary">{props.task.observaciones ? props.task.observaciones : '-'}</Text>
          </div>
          <div className="tp-task-map__description__content__information">
            <Text strong>Asignado(s):</Text>
            <List
              className="tp-task-map__description__content__information__list"
              dataSource={props.task.tareaUsuario}
              renderItem={(task, key) => (
                <List.Item key={key}>
                  <List.Item.Meta
                    avatar={
                      <Avatar
                        size={'large'}
                        style={{
                          color: '#FFFFFF',
                          backgroundColor: '#D9D9D9',
                        }}
                      >
                        {createInitialNames(task.usuario?.nombre, task.usuario?.apellido)}
                      </Avatar>
                    }
                    title={
                      <Text className="tp-task-map__description__content__information_user__name">
                        {task.usuario?.nombre} {task.usuario?.apellido}
                      </Text>
                    }
                    description={task.anotaciones && 
                      <span className={'ver_notas'} onClick={()=>showModalVerNotas(`${task.usuario?.nombre} ${task.usuario?.apellido}`, props.task.titulo as string, task.anotaciones as string)}>Ver notas</span>
                    }
                  />
                  <div>
                    <Tag className={taskStateUsers(task?.estado as number).className}>
                      {taskStateUsers(task?.estado as number).title}
                    </Tag>
                  </div>
                </List.Item>
              )}
            />
          </div>
          <div className="tp-task-map__description__content__information">
            <Text strong>Realización:</Text>
            <Text type="secondary">
              {props.task.fechaDesde ? moment(props.task.fechaDesde).format('DD/MM/YYYY') : ''} - {' '}
              {props.task.fechaHasta ? moment(props.task.fechaHasta).format('DD/MM/YYYY') : ''} 
            </Text>
          </div>
        </div>
        <div className='footer-description'>
        {
            readOnly() ? 
            <div className="tp-task-map__content_actions_read_only">
            <Button
              shape="round"
              icon={<ArrowLeftOutlined />}
              onClick={() => {
                navigateToTaskView();
              }}
            >
              Regresar
            </Button>
            </div> :
            <div className="tp-task-map__content_actions">
            <Button
              shape="round"
              icon={<ArrowLeftOutlined />}
              onClick={() => {
                navigateToTaskView();
              }}
            >
              Regresar
            </Button>
            {
              props.task.isClosable ?               
              <Button
              type="primary"
              shape="round"
              className="close-task"
              icon={<CloseTask />}
              onClick={() => {
                dispatch(setShowNotaDeCierreModal(true));
              }}
              >
              Cerrar tarea
              </Button> : 
              <Button
              type="primary"
              shape="round"
              icon={<EditOutlined />}
              onClick={() => {
                editTaskForm();
              }}
            >
              Editar Tarea
            </Button>
            }
            </div>
          }
        </div>
        <Row>
          <Col>
            <CloseNoteTaskModal />
          </Col>
        </Row>
        <Row>
          <Col>
            {showNotas && 
              <Anotaciones 
                notas={infoNotas} 
                closeModalNotas={closeModalVerNotas}
              />
            }
          </Col>
        </Row>
    </div>
  );
}
export default TaskMapDescription;
